module.exports = __webpack_public_path__ + "img/success.e2fe6a8c.png";